import "./styled/security.scss";
import SliderBannerLogin from "./slider-banner";
import { isAptelBirthday } from "../layouts/ticker";

const BDAY_TEXT = "Happy Birthday!";

// curved text under the logo: letters appear one by one, then a gold shine sweeps across every 5s
const BirthdayText = () => {
	const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
	return (
		<svg className="bday-text" viewBox="0 0 120 36" aria-hidden="true">
			<defs>
				<path id="bday-arc" d="M8 6Q60 40 112 6" />
				{/* parked off to the right so the text is plain red between sweeps */}
				<linearGradient id="bday-shine" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="120" y2="0" gradientTransform="translate(130 0)">
					<stop offset="0.3" stopColor="#e64225" />
					<stop offset="0.5" stopColor="#ffc23a" />
					<stop offset="0.7" stopColor="#e64225" />
					{!reduceMotion && (
						<animateTransform attributeName="gradientTransform" type="translate" values="-130 0;130 0;130 0" keyTimes="0;0.24;1" dur="5s" begin="2.5s" repeatCount="indefinite" />
					)}
				</linearGradient>
			</defs>
			<text fontFamily="Pacifico, Segoe UI, Tahoma, Arial" fontSize="13" fill="url(#bday-shine)" stroke="#fff" strokeWidth="2.5" paintOrder="stroke" textAnchor="middle">
				<textPath href="#bday-arc" startOffset="50%">
					{[...BDAY_TEXT].map((c, i) => (
						<tspan key={i} style={{ "--i": i }}>
							{c === " " ? "\u00a0" : c}
						</tspan>
					))}
				</textPath>
			</text>
		</svg>
	);
};

// confetti that bursts out of the logo each time the hat tips (same 5s beat): [x px, y px, spin deg, color, round]
const CONFETTI = [
	[-62, -34, 220, "#e64225"],
	[-48, -58, -160, "#fbca4b", true],
	[-22, -70, 300, "#7c1118"],
	[6, -76, -240, "#ffc23a"],
	[30, -66, 180, "#ed537d", true],
	[54, -50, -300, "#e64225"],
	[66, -22, 260, "#fbca4b"],
	[-70, -6, -200, "#fa9a86", true],
	[72, 8, 140, "#7c1118"],
	[-40, -40, 320, "#ffc23a"],
	[40, -36, -120, "#fa9a86"],
	[-8, -50, 200, "#e64225", true],
	[20, -86, -280, "#fbca4b"],
	[-58, 14, 240, "#ed537d"],
];

const Confetti = () => (
	<span className="bday-confetti" aria-hidden="true">
		{CONFETTI.map(([x, y, r, c, round], i) => (
			<i key={i} className={round ? "round" : undefined} style={{ "--x": `${x}px`, "--y": `${y}px`, "--r": `${r}deg`, "--c": c, animationDelay: `${2.5 + (i % 4) * 0.03}s` }} />
		))}
	</span>
);

// shared shell for login / OTP / forgot & reset password: form on the start side, brand panel with banners on the end side
const LayoutLogin = ({ children }) => {
	const bday = isAptelBirthday();
	const img = (name) => process.env.PUBLIC_URL + process.env.REACT_APP_PATH + "/assets/images/" + name;
	return (
		<div className="auth">
			<main className="auth-form-side">
				<div className="auth-form form-box-handle">
					<div className="holder-icon">
						<span className={bday ? "bday-hat" : undefined}>
							<img src={img("logo-hd.png")} alt="آپتل" className="auth-logo" />
							{bday && <BirthdayText />}
							{bday && <Confetti />}
						</span>
						<img src={img("text-logo.png")} alt="سامانه فروش نمایندگان آپتل" className="auth-wordmark" />
					</div>
					<div className="holder-form">{children}</div>
				</div>

				<footer className="auth-help">
					<a href="https://www.aptel.ir/dealer-support/distributors" target="_blank" rel="noreferrer">
						<i className="icon-pdf" aria-hidden="true"></i>
						اطلاعات توزیع کنندگان جهت دریافت نمایندگی و خرید کیت
					</a>
					<p>
						پشتیبانی ۲۴ ساعته نمایندگان:{" "}
						<a href="tel:09991000000" dir="ltr">
							0999 100 0000
						</a>{" "}
						داخلی ۱
					</p>
				</footer>
			</main>

			<aside className="auth-brand" aria-label="اطلاعیه‌های آپتل">
				<img className="auth-brand-decor" src={img("logo-big.png")} alt="" aria-hidden="true" />
				<div className="auth-brand-inner">
					<h2>
						<img src={img("logo-small.png")} alt="" aria-hidden="true" className="auth-brand-mark" />
						سامانه فروش نمایندگان آپتل
					</h2>
					<p>ثبت‌نام سیم‌کارت، فروش شارژ و بسته و مدیریت کیف پول، همه در یک پنل.</p>
					<div className="banner-box-handle">
						<SliderBannerLogin />
					</div>
				</div>
			</aside>
		</div>
	);
};

export default LayoutLogin;
